import i18n from '@/lang/i18n'
import { TYPES } from '@/entities/fields'

const COLUMNS = [
    {
        headerName: i18n.t('entities.creation.labels.key'),
        field: 'key',
        type: TYPES.STRING,
    },
    {
        field: 'name',
        headerName: i18n.t('entities.creation.labels.name'),
        type: TYPES.STRING,
    },
    {
        field: 'description',
        headerName: i18n.t('entities.creation.labels.description'),
        type: TYPES.STRING,
    },
    {
        field: 'groupKey',
        headerName: i18n.t('entities.creation.labels.group'),
        type: TYPES.STRING,
    },
    {
        field: 'type',
        headerName: i18n.t('entities.creation.labels.type'),
        type: TYPES.STRING,
    },
    {
        field: 'default',
        headerName: i18n.t('entities.creation.labels.defaultExpression'),
        type: TYPES.BOOL,
        width: 180,
        suppressSizeToFit: true,
    },
    {
        field: 'validators',
        headerName: i18n.t('entities.creation.labels.validators'),
        type: TYPES.BOOL,
        width: 120,
        suppressSizeToFit: true,
    },
    {
        field: 'locked',
        headerName: i18n.t('entities.creation.labels.locked'),
        type: TYPES.BOOL,
        width: 100,
        suppressSizeToFit: true,
    },
    {
        field: 'editable',
        headerName: i18n.t('entities.creation.labels.editable'),
        type: TYPES.BOOL,
        width: 100,
        suppressSizeToFit: true,
    },
    {
        field: 'visible',
        headerName: i18n.t('entities.creation.labels.visible'),
        type: TYPES.BOOL,
        width: 100,
        suppressSizeToFit: true,
    },
]

export const transformRequestData = (data) => {
    if (data) {
        const rows = data.map((f) => {
            const visible = !f.hidden
            const datum = {
                ...f,
                visible,
            }

            return {
                ...f,
                default: !!f.default,
                validators: !!Object.keys(f.validators || {}).length || !!f.dictionary,
                visible,
                datum,
            }
        })

        return {
            columns: COLUMNS,
            rows,
        }
    }

    return {}
}

export default {
    transformRequestData,
}
